import React from 'react'
import { Panel, Placeholder } from 'rsuite'
import './styles.less'

const { Paragraph } = Placeholder

export default function PanalLoadingTemplate() {
  return (
    <div className="panal-loading-template">
      <div className="panal-loading-template__page-header">
        <Paragraph rows={1}></Paragraph>
        <Paragraph rows={1}></Paragraph>
      </div>
      <hr />
      <Panel shaded bordered defaultExpanded>
        <Paragraph rows={10}></Paragraph>
      </Panel>
    </div>
  )
}
